module.exports = __webpack_public_path__ + "static/slide-3-2972c25e4b982b6dda7c9ebf25c641df.jpg";